const isLoggedIn = require('module/viewer/helpers/is_logged_in')

module.exports = function isAdmin(viewer) {
    if (! isLoggedIn(viewer)) return false
    if (! viewer.flags) return false
    return viewer.flags.admin
}
